import * as React from "react";
import { useFieldProps } from "src/hooks/form/useField";
import { useSelect, useStaticSelect } from "src/hooks/form/useSelect";
import { fetchAddresses } from "src/api/organisationProfiling";
import { SEAddressType, SELocationType } from "src/components/pages/shipment-execution/SE.interfaces";

const useAddress = <T>(
  props: useFieldProps<T>,
  defaultAddressType?: SEAddressType,
  defaultLocationType?: SELocationType
) => {
  const [addressType, setAddressType] = React.useState(defaultAddressType);
  const [locationType, setLocationType] = React.useState(defaultLocationType);
  const field = useSelect(
    props,
    () => fetchAddresses({ addressType, locationType }),
    (data) => data?.map((el) => ({ key: el.id, label: el.name, ...el })) || []
  );

  React.useEffect(() => {
    field.setApi(() => fetchAddresses({ addressType, locationType }));
  }, [addressType, locationType]);

  return {
    ...field,
    addressType,
    locationType,
    setAddressType,
    setLocationType
  };
};

export default useAddress;
